import axios from "axios"
import React, {Component} from "react"
import ApiHelper from "src/ApiHelper"
import DeveloperPortalCredentialsRow from "src/components/table/DeveloperPortalCredentialsRow"
class DeveloperPortalCredentials extends Component{
    constructor(props){
        super(props)
        console.log("Brokerage")
        this.state = {
            addcredentialsform: {
                emailid: "",
                password: "",
                message: ""
            },
            deletecredentialsform: {
                serialid: "",
                message: ""
            },
            credentialsoffset: 0,
            credentialslist: []
        }
    }
    showCredentialsList(){
        var rows = []
        for(var i = 0; i < this.state.credentialslist.length; i++){
            rows.push(<DeveloperPortalCredentialsRow deletehandler={this.onDeleteCredentialClicked.bind(this)} superadminhandler={this.onUpdateSuperAdminStatusClicked.bind(this)} key={this.state.credentialslist[i].serial_id} serialid={this.state.credentialslist[i].serial_id} emailid={this.state.credentialslist[i].email_id} superadmin={this.state.credentialslist[i].superadmin} />)
        }
        return rows
    }
    render(){
        return <div className="c_developerportal_content">
            <h4>Add Credential</h4>
            <input name="emailid" className="c_developerportal_inputonwhite" value={this.state.addcredentialsform.emailid} onChange={this.onAddCredentialFormChanged.bind(this)} placeholder="Email ID"/>  
            <input name="password" className="c_developerportal_inputonwhite" type="password" value={this.state.addcredentialsform.password} onChange={this.onAddCredentialFormChanged.bind(this)} placeholder="Password"/>  
            <button onClick={this.onAddCredentialClicked.bind(this)} className="c_developerportal_buttononwhite">Submit</button>
            <p>{this.state.addcredentialsform.message}</p>
            <h4>Credentials List</h4>
            <div className="c_developerportal_searchresults">
                {this.showCredentialsList()}
            </div>
            <button className="c_developerportal_buttononwhite" onClick={this.decrementCredentialsOffset.bind(this)}>Prev</button>
            <button className="c_developerportal_buttononwhite" onClick={this.incrementCredentialsOffset.bind(this)}>Next</button>
        </div>
    }
    onDeleteCredentialClicked(credentialid){
        var deletecredential = axios.post(ApiHelper.credentials.deleteCredential, {credentialid}, ApiHelper.getAccessTokenHeaderConfig())
        deletecredential.then(response => {
            alert(response.data.error_message)
            this.getCredentialsByOffset()
        }, error=> {
            alert(error.response.data.error_message)
        })
    }
    onUpdateSuperAdminStatusClicked(superadminstatus, credentialid){
        var updatesuperadminstatus = axios.post(ApiHelper.credentials.updateSuperAdminStatus, {credentialid, superadminstatus}, ApiHelper.getAccessTokenHeaderConfig())
        updatesuperadminstatus.then(response => {
            alert(response.data.error_message)
            this.getCredentialsByOffset()
        }, error=> {
            alert(error.response.data.error_message)
        })
    }
    onAddCredentialFormChanged(event){
        const newstate = {...this.state}
        newstate.addcredentialsform[event.target.name] = event.target.value
        this.setState(newstate)
    }
    onAddCredentialClicked(){
        // alert(`${this.state.addcredentialsform.emailid} ${this.state.addcredentialsform.password}`)
        var addcredential = axios.post(ApiHelper.credentials.addCredential, {emailid: this.state.addcredentialsform.emailid, password: this.state.addcredentialsform.password}, ApiHelper.getAccessTokenHeaderConfig())
        addcredential.then(response => {
            alert(response.data.error_message)
            this.getCredentialsByOffset()
        }, error=> {
            alert(error.response.data.error_message)
        })
    }
    incrementCredentialsOffset(){
        const newstate = {...this.state}
        newstate.credentialsoffset += 10
        this.setState(newstate, () => {
            this.getCredentialsByOffset()
        })
    }
    decrementCredentialsOffset(){
        const newstate = {...this.state}
        newstate.credentialsoffset -= this.state.credentialsoffset - 10 >= 0? 10: 0
        this.setState(newstate, () => {
            this.getCredentialsByOffset()
        })
    }
    getCredentialsByOffset(){
        var getcredentials = axios.post(ApiHelper.credentials.getCredentialsByOffset, {offset: this.state.credentialsoffset}, ApiHelper.getAccessTokenHeaderConfig())
        getcredentials.then(response => {
            const newstate = {...this.state}
            newstate.credentialslist = response.data.data
            this.setState(newstate)
        }, error=> {
            console.log(error.response.error_message)
        })
    }
    componentDidMount(){
        this.props.setLoading(false)
        this.getCredentialsByOffset()
    }
}
export default DeveloperPortalCredentials